var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 24,
    height: 24,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_24",
    "data-name": "Mask Group 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "conversation",
    transform: "translate(2.911 4.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M10.569,19.288a.642.642,0,0,1-.459-.191l-2.427-2.41H3.963A2.722,2.722,0,0,1,1.25,13.974V5.963A2.722,2.722,0,0,1,3.963,3.25H17.175a2.722,2.722,0,0,1,2.713,2.713v8.01a2.722,2.722,0,0,1-2.713,2.713H13.439l-2.41,2.41a.642.642,0,0,1-.459.191ZM3.963,4.55A1.413,1.413,0,0,0,2.55,5.963v8.01a1.413,1.413,0,0,0,1.413,1.413H7.969a.65.65,0,0,1,.459.191l2.141,2.141,2.141-2.141a.65.65,0,0,1,.459-.191h4.005a1.413,1.413,0,0,0,1.413-1.413V5.963A1.413,1.413,0,0,0,17.175,4.55Z",
    transform: "translate(-1.25 -3.25)",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M14.652,11.55H8.15a.65.65,0,1,1,0-1.3h6.5a.65.65,0,1,1,0,1.3Z",
    transform: "translate(-2.082 -4.182)",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M14.652,14.55H8.15a.65.65,0,1,1,0-1.3h6.5a.65.65,0,0,1,0,1.3Z",
    transform: "translate(-2.082 -4.581)",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M14.652,8.55H8.15a.65.65,0,1,1,0-1.3h6.5a.65.65,0,0,1,0,1.3Z",
    transform: "translate(-2.082 -3.782)",
    fill: "#171926"
  })))));
};
export default SvgMessage;